import service from '@/request/http.js'



export const scoollist = () => {
	return service({
		url: 'School/GetSchoolList',
		method: 'get',
		showLoading: false
	})
};

export const validatem = (data) => {
	return service({
		url: 'user/GetQrCode?ui_userName=' + data,
		method: 'get',
		showLoading: false
	})
};

export const IndexSendEmail = (data) => {
	return service({
		url: 'Index/SendEmail',
		method: 'post',
		showLoading: false,
		data

	})
};

export const IndexEditPassWord = (data) => {
	return service({
		url: 'Index/EditPassWord',
		method: 'post',
		showLoading: false,
		data
	})
};

export const DataWallGetTrainSTA = (data) => { //实训统计数据
	return service({
		url: 'DataWall/GetTrainSTA?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainSTANewAPI = (data) => { //新实训统计数据
	return service({
		url: 'DataWall/GetTrainSTANew?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const DataWallGetTrainCount = (data) => { // 获取本周实训人数统计
	return service({
		url: 'DataWall/GetTrainCount?si_guid=' + data.si_guid + "&time=" + data.time,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainCountNewCountApi = (data) => { // 新获取本周实训人数统计
	return service({
		url: 'DataWall/GetTrainCountNew?si_guid=' + data.si_guid + "&time=" + data.time,
		method: 'get',
		showLoading: false
	})
};



export const GetTrainEquipmentStatusSTA = (data) => {
	return service({
		url: 'DataWall/GetTrainEquipmentStatusSTA?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainUsageSTA = (data) => {
	return service({
		url: 'DataWall/GetTrainUsageSTA?si_guid=' + data.si_guid + "&month=" + data.month,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainSingleDataList = (data) => { // 个人实训排行榜
	return service({
		url: 'DataWall/GetTrainSingleDataList?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainSingleDataListNewApi = (data) => { // 新个人实训排行榜
	return service({
		url: 'DataWall/GetTrainSingleDataListNew?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainSingleDataListNewCQApi = (data) => { // 模拟驾驶个人实训排行榜
	return service({
		url: 'DataWall/GetTrainSingleDataListNewCQ?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};


export const GetTrainClassDataListNewAPi = (data) => { // 新班级实训排行榜
	return service({
		url: 'DataWall/GetTrainClassDataListNew?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetPageAppointDataList = (data) => {
	return service({
		url: 'DataWall/GetPageAppointDataList?si_guid=' + data.si_guid + "&pageIndex=" + data.pageIndex +
			"&pageSize=" + data.pageSize,
		method: 'get',
		showLoading: false
	})
};


export const GetTrainTimeLengthDataList = (data) => { //设备实训时长统计
	return service({
		url: 'DataWall/GetTrainTimeLengthDataList?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetTrainTimeLengthDataListNewApi = (data) => { // 新设备实训时长统计
	return service({
		url: 'DataWall/GetTrainTimeLengthDataListNew?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};


export const TrainingequipmentTimeApi = (data) => { // 模拟驾驶设备实训时长统计
	return service({
		url: 'DataWall/TrainingequipmentTime?si_guid=' + data + "&Year=",
		method: 'get',
		showLoading: false
	})
};


export const GetClassInfoList = (data) => {
	return service({
		url: 'DataWall/GetClassInfoList?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetStudentInfoList = (data) => {
	return service({
		url: 'DataWall/GetStudentInfoList?si_guid=' + data.si_guid + "&cla_guid=" + data.cla_guid,
		method: 'get',
		showLoading: false
	})
};

export const GetStudentInfo = (data) => {
	return service({
		url: 'DataWall/GetStudentInfo?ui_guid=' + data,
		method: 'get',
		showLoading: false
	})
};


export const GetStudentTimeLength = (data) => {
	return service({
		url: 'DataWall/GetStudentTimeLength?ui_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

// 
export const GetStudentTimeLengthApi = (data) => { // 学习时长
	return service({
		url: 'DataWall/GetStudentTimeLengthNew?ui_guid=' + data.ui_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get',
		showLoading: false
	})
};



export const GetStudentResultsDataList = (data) => {
	return service({
		url: 'DataWall/GetStudentResultsDataList?ui_guid=' + data.ui_guid + "&type=" + data.type,
		method: 'get',
		showLoading: false
	})
};

export const GetStudentResultsDataListApi = (data) => {
	return service({
		url: 'DataWall/GetStudentResultsDataListNew?ui_guid=' + data.ui_guid + "&type=" + data.type +
			"&sx_te_guid=" + data.sx_te_guid,
		method: 'get',
		showLoading: false
	})
};

// 实训成绩模拟驾驶
export const TrainingTaskStatisticsApi = (data) => {
	return service({
		url: '/DataWall/TrainingTaskStatistics?ui_guid=' + data.ui_guid + "&sx_te_guid=",
		method: 'get',
		showLoading: false
	})
};


export const GetMyComprehensiveSTA = (data) => {
	return service({
		url: 'DataWall/GetMyComprehensiveSTA?ui_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetMyComprehensiveSTAPi = (data) => {
	return service({
		url: 'DataWall/GetMyComprehensiveSTANew?ui_guid=' + data.ui_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get',
		showLoading: false
	})
};


export const GetMyProjectSTA = (data) => {
	return service({
		url: 'DataWall/GetMyProjectSTA?ui_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

export const GetMyProjectSTANewApi = (data) => {
	return service({
		url: 'DataWall/GetMyProjectSTANew?ui_guid=' + data.ui_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get',
		showLoading: false
	})
};


export const GetMyTrainDataSTA = (data) => {
	return service({
		url: 'DataWall/GetMyTrainDataSTA?ui_guid=' + data.ui_guid + "&pageIndex=" + data.pageIndex,
		method: 'get',
		showLoading: false
	})
};
// 
export const GetMyTrainDataSTANewApi = (data) => {
	return service({
		url: 'DataWall/GetMyTrainDataSTANew?ui_guid=' + data.ui_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get',
		showLoading: false
	})
};

// 模拟驾驶数据报表
export const GetMyTrainDataSTANewCQApi = (data) => {
	return service({
		url: 'DataWall/GetMyTrainDataSTANewCQ?ui_guid=' + data.ui_guid,
		method: 'get',
		showLoading: false
	})
};
// 达标度
export const GetTaskComplianceApi = (data) => {
	return service({
		url: 'DataWall/GetTaskCompliance?ui_guid=' + data.ui_guid+"&sx_te_guid=",
		method: 'get',
		showLoading: false
	})
};

// 



export const GetPublicProfList = (data) => {
	return service({
		url: 'Professional/GetPublicProfList?si_guid=' + data,
		method: 'get',
		showLoading: false
	})
};

// /ClassInfo/GetPublicProClassList
export const GetPublicProClassList = (data) => {
	return service({
		url: 'ClassInfo/GetPublicProClassList?si_guid=' + data.si_guid + "&pro_guid=" + data.pro_guid,
		method: 'get',
		showLoading: false
	})
};

//  是否同步数据
export const GetDatasyncApi = (data) => {
	return service({
		url: 'DataSynchronization/GetDatasync?ui_guid=' + data,
		method: 'get',
		showLoading: false
	})
};